import { memo, FC } from "react";

interface ClassicLinkProps {
  href?: string;
  children?: React.ReactNode;
  target?: "_blank" | "_self" | "_parent" | "_top";
}

export const ClassicLink: FC<ClassicLinkProps> = memo((props) => {
  const { href, children, target = "_blank" } = props;
  return (
    <a href={href} target={target} className="text-blue-500 hover:text-blue-700 underline">
      {children}
    </a>
  );
});
